import classNames from 'classnames';
import { createElement, CSSProperties, PropsWithChildren } from 'react';
import styles from './Typography.module.scss';

/**
 * @deprecated Heading variants on `Typography` are deprecated. Use the Denali
 * `Heading` component (`@alltrails/denali/components/Heading`) instead.
 */
type DeprecatedHeadingVariant = 'heading100' | 'heading200' | 'heading300' | 'heading400' | 'heading500' | 'heading600' | 'heading700';

type Props = {
  className?: string;
  color?: 'error' | 'inverse' | 'light' | 'secondary' | 'primary' | 'tertiary';
  component?: 'div' | 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4';
  id?: string;
  itemProp?: string;
  mb?: '0' | '8' | '12' | '16' | '24' | '32' | '48' | '64';
  mt?: '0' | '8' | '12' | '16' | '24' | '32' | '48' | '64';
  style?: CSSProperties;
  /**
   * Note: `heading*` variants are deprecated. Use the Denali `Heading`
   * component (`@alltrails/denali/components/Heading`) instead.
   */
  variant:
    | DeprecatedHeadingVariant
    | 'paragraph100'
    | 'paragraph200'
    | 'paragraph300'
    | 'text50'
    | 'text50bold'
    | 'text100'
    | 'text100bold'
    | 'text150'
    | 'text150bold'
    | 'text200'
    | 'text200bold'
    | 'text300'
    | 'text300bold';
};

// loosely based upon https://mui.com/components/typography/
export default function Typography({
  children,
  className,
  color = 'primary',
  component = 'span',
  id,
  mb,
  mt,
  style,
  variant,
  itemProp
}: PropsWithChildren<Props>) {
  const variantClassName = styles[variant!];

  // because of css-loader exportLocalsConvention camelCase the X is uppercase
  // Maybe we should see what library/logic css-loader uses for camel-casing and clone that here?
  const mbClassName = mb && styles[`mb${mb}`];
  const colorClassName = color && styles[color];
  const mtClassName = mt && styles[`mt${mt}`];
  return createElement(
    component,
    { className: classNames(variantClassName, mbClassName, colorClassName, mtClassName, className), id, itemProp, style },
    children
  );
}
